<div class="mb-5">
    <h5 class="text-blue-700">{{ titulo }}</h5>
    {{ descricao }}
</div>